module.exports = __webpack_public_path__ + "assets/img/square_cap_icon.svg";